// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2rN0j","title":"ClientReferral_title__2xJSE","itemText":"ClientReferral_itemText__2tQKv"};